const easeInOut = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
const webLoader = (options = {}) => {
    const { strokeWidth = 10, size = 100, duration = 1200, colors = ['#4285f4', '#ed3e35', '#f7c223', '#1b9a59'], } = options;
    const circleSize = size / 2;
    const circleRadius = circleSize - strokeWidth / 2;
    const circleDash = 2 * Math.PI * circleRadius;
    const wrapperEl = document.createElement('div');
    const spinnerEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const circleEl = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    Object.assign(wrapperEl.style, {
        alignItems: 'center',
        backgroundColor: '#fff',
        bottom: '0',
        display: 'flex',
        justifyContent: 'center',
        left: '0',
        position: 'fixed',
        right: '0',
        top: '0',
        zIndex: '100',
    });
    Object.assign(spinnerEl.style, { fill: 'transparent' });
    spinnerEl.setAttribute('height', String(size));
    spinnerEl.setAttribute('stroke-linecap', 'round');
    spinnerEl.setAttribute('viewBox', `0 0 ${size} ${size}`);
    spinnerEl.setAttribute('width', String(size));
    circleEl.style.transformOrigin = 'center';
    circleEl.setAttribute('cx', String(circleSize));
    circleEl.setAttribute('cy', String(circleSize));
    circleEl.setAttribute('r', String(circleRadius));
    circleEl.setAttribute('stroke-dasharray', String(circleDash));
    circleEl.setAttribute('stroke-width', String(strokeWidth));
    spinnerEl.appendChild(circleEl);
    wrapperEl.appendChild(spinnerEl);
    document.body.appendChild(wrapperEl);
    let rafId;
    let startTime = null;
    const animate = (timestamp) => {
        if (startTime === null)
            startTime = timestamp;
        const elapsed = timestamp - startTime;
        // Rotation: 0→360 linear, loops every `duration`
        const rotationProgress = (elapsed % duration) / duration;
        spinnerEl.style.transform = `rotate(${rotationProgress * 360}deg)`;
        // Dash offset: easeInOut ping-pong between full dash and strokeWidth, half period each way
        const halfDuration = duration / 2;
        const dashElapsed = elapsed % duration;
        const dashT = dashElapsed < halfDuration
            ? easeInOut(dashElapsed / halfDuration)
            : easeInOut(1 - (dashElapsed - halfDuration) / halfDuration);
        const dashOffset = circleDash * (1 - 0.9 * dashT);
        circleEl.setAttribute('stroke-dashoffset', String(dashOffset));
        // Color: cycle through colors array, one per `duration * colors.length`
        const colorDuration = duration * colors.length;
        const colorIndex = Math.floor(((elapsed % colorDuration) / colorDuration) * colors.length);
        circleEl.style.stroke = colors[colorIndex];
        rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);
    const loaderStartTime = Date.now();
    return {
        remove: () => {
            const elapsed = Date.now() - loaderStartTime;
            const delay = Math.max(0, 1000 - elapsed);
            setTimeout(() => {
                wrapperEl.style.transition = 'opacity 300ms ease-in-out';
                wrapperEl.style.opacity = '0';
                setTimeout(() => {
                    var _a;
                    cancelAnimationFrame(rafId);
                    (_a = wrapperEl.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(wrapperEl);
                }, 300);
            }, delay);
        },
    };
};
export default webLoader;
